import { Injectable } from '@angular/core';
import { HttpclienterrorService } from '../interceptor/httpclienterror.service';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import {
  MessageCenterQuizClass,
  MessageCenterStatusClass,
  MessageCenterTransactionClass,
  MessageCenterTransactionDetailClass,
  MessageCenterTransactionOpenedClass,
} from '../models/messagecenter-class';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { FilesClass } from '../models/uploads-class';
import dayjs from 'dayjs';

@Injectable({
  providedIn: 'root',
})
export class MessagecenterService {
  constructor(
    private http: HttpClient,
    public httpclienterrorService: HttpclienterrorService,
  ) {}

  CreateTicketRCAlojamento(data: FormData): Observable<any> {
    return this.http.post<any>(environment.URL + `/messagecenter/CreateTicketRCAlojamento`, data).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetMessageCenterTransactionCustomerInteraccoes(
    IdCommercial: number,
    idCustomer: number,
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    statuses: string,
  ): Observable<MessageCenterTransactionClass[]> {
    const formattedStartDate = startDate.format('YYYY-MM-DD 00:00:00');
    const formattedEndDate = endDate.format('YYYY-MM-DD 23:59:59');

    return this.http
      .get<
        MessageCenterTransactionClass[]
      >(environment.URL + `/messagecenter/GetMessageCenterTransactionCustomerInteraccoes/${IdCommercial}/${idCustomer}/${encodeURIComponent(formattedStartDate)}/${encodeURIComponent(formattedEndDate)}/${encodeURIComponent(statuses)}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterTransactionCustomerInsuranceClaim(
    IdCommercial: number,
    idCustomer: number,
    idInsuranceClaims: number,
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    statuses: string,
  ): Observable<MessageCenterTransactionClass[]> {
    const formattedStartDate = startDate.format('YYYY-MM-DD 00:00:00');
    const formattedEndDate = endDate.format('YYYY-MM-DD 23:59:59');

    return this.http
      .get<
        MessageCenterTransactionClass[]
      >(environment.URL + `/messagecenter/GetMessageCenterTransactionCustomerInsuranceClaim/${IdCommercial}/${idCustomer}/${idInsuranceClaims}/${encodeURIComponent(formattedStartDate)}/${encodeURIComponent(formattedEndDate)}/${encodeURIComponent(statuses)}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterTransactionGetMinDate(): Observable<Date[]> {
    return this.http.get<Date[]>(environment.URL + `/messagecenter/GetMessageCenterTransactionGetMinDate`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetMessageCenterTransactionGetMinDateCustomer(idCustomer: number): Observable<Date[]> {
    return this.http
      .get<Date[]>(environment.URL + `/messagecenter/GetMessageCenterTransactionGetMinDateCustomer/${idCustomer}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterTransactionUpdateRecords() {
    return this.http.get(environment.URL + `/messagecenter/GetMessageCenterTransactionUpdateRecords`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  MessageCenterTransactionDetailFiles(file: FilesClass, uuid: string): Observable<any> {
    file.UUIDLastChange = uuid;

    return this.http.post<any>(environment.URL + `/messagecenter/MessageCenterTransactionDetailFiles`, file).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  MessageCenterTransactionDetail(
    messageCenterTransactionDetailClass: MessageCenterTransactionDetailClass,
    uuid: string,
  ): Observable<MessageCenterTransactionDetailClass> {
    // tslint:disable-next-line:object-literal-shorthand
    messageCenterTransactionDetailClass.UUIDLastChange = uuid;

    return this.http
      .post<MessageCenterTransactionDetailClass>(
        environment.URL + `/messagecenter/MessageCenterTransactionDetail`,
        messageCenterTransactionDetailClass,
      )
      .pipe(
        map(resp => this.pickFirstRow<MessageCenterTransactionDetailClass>(resp)!),
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterTransactionFiles(
    IdCommercial: number,
    idMessageCenterTransactionDetail: number,
  ): Observable<FilesClass[]> {
    return this.http
      .get<
        FilesClass[]
      >(environment.URL + `/messagecenter/GetMessageCenterTransactionFiles/${IdCommercial}/${idMessageCenterTransactionDetail}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterTransactionDetail(
    IdMessageCenterTransaction: number,
    IdCommercial: number,
  ): Observable<MessageCenterTransactionDetailClass[]> {
    return this.http
      .get<
        MessageCenterTransactionDetailClass[]
      >(environment.URL + `/messagecenter/GetMessageCenterTransactionDetail/${IdMessageCenterTransaction}/${IdCommercial}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterStatus(): Observable<MessageCenterStatusClass[]> {
    return this.http.get<MessageCenterStatusClass[]>(environment.URL + `/messagecenter/GetMessageCenterStatus`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GetMessageCenterTransactionALL(
    IdCommercial: number,
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    statuses: string,
  ): Observable<MessageCenterTransactionClass[]> {
    const formattedStartDate = startDate.format('YYYY-MM-DD 00:00:00');
    const formattedEndDate = endDate.format('YYYY-MM-DD 23:59:59');

    return this.http
      .get<
        MessageCenterTransactionClass[]
      >(environment.URL + `/messagecenter/GetMessageCenterTransactionALL/${IdCommercial}/${encodeURIComponent(formattedStartDate)}/${encodeURIComponent(formattedEndDate)}/${encodeURIComponent(statuses)}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterTransactionCustomer(
    IdCommercial: number,
    idCustomer: number,
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    statuses: string,
  ): Observable<MessageCenterTransactionClass[]> {
    const formattedStartDate = startDate.format('YYYY-MM-DD 00:00:00');
    const formattedEndDate = endDate.format('YYYY-MM-DD 23:59:59');

    return this.http
      .get<
        MessageCenterTransactionClass[]
      >(environment.URL + `/messagecenter/GetMessageCenterTransactionCustomer/${IdCommercial}/${idCustomer}/${encodeURIComponent(formattedStartDate)}/${encodeURIComponent(formattedEndDate)}/${encodeURIComponent(statuses)}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterTransactionCustomerInsurancePolicy(
    IdCommercial: number,
    idCustomer: number,
    idInsurancePolicy: number,
    startDate: dayjs.Dayjs,
    endDate: dayjs.Dayjs,
    statuses: string,
  ): Observable<MessageCenterTransactionClass[]> {
    const formattedStartDate = startDate.format('YYYY-MM-DD 00:00:00');
    const formattedEndDate = endDate.format('YYYY-MM-DD 23:59:59');

    return this.http
      .get<
        MessageCenterTransactionClass[]
      >(environment.URL + `/messagecenter/GetMessageCenterTransactionCustomerInsurancePolicy/${IdCommercial}/${idCustomer}/${idInsurancePolicy}/${encodeURIComponent(formattedStartDate)}/${encodeURIComponent(formattedEndDate)}/${encodeURIComponent(statuses)}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterTransaction(
    IdMessageCenterTransaction?: number,
    IdMessageCenterQuiz?: number,
    IdCompanie?: number,
    IdProduct?: number,
    IdProductsTypes?: number,
    IdInsurancePolicy?: number,
    IdInsuranceClaims?: number,
    IdCustomer?: number,
    IdCommercial?: number,
  ): Observable<MessageCenterTransactionClass[]> {
    return this.http
      .get<
        MessageCenterTransactionClass[]
      >(environment.URL + `/messagecenter/GetMessageCenterTransaction/${IdMessageCenterTransaction}/${IdMessageCenterQuiz}/${IdCompanie}/${IdProduct}/${IdProductsTypes}/${IdInsurancePolicy}/${IdInsuranceClaims}/${IdCustomer}/${IdCommercial}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GetMessageCenterTransactionID(idMessageCenterTransaction?: number): Observable<MessageCenterTransactionClass[]> {
    return this.http
      .get<
        MessageCenterTransactionClass[]
      >(environment.URL + `/messagecenter/GetMessageCenterTransactionID/${idMessageCenterTransaction}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  SETMessageCenterTransaction(
    messageCenterTransactionClass: MessageCenterTransactionClass,
    uuid: string,
  ): Observable<MessageCenterTransactionClass> {
    // Clone object to avoid side effects on the UI model
    const toSend = { ...messageCenterTransactionClass };

    // Remover propriedades pesadas que o backend não utiliza.
    // O backend apenas lê campos escalares (24 parâmetros da SP).
    // O array de detalhes pode conter ficheiros com previewURL em base64,
    // facilmente a ultrapassar o client_max_body_size do nginx (413).
    delete (toSend as any).messageCenterTransactionDetailClass;

    // Helper formatting function
    const formatForMySQL = (d: any) => {
      if (!d) return null;
      // If it's already a string, try to keep it or reformat if needed.
      // dayjs(string) works fine.
      return dayjs(d).format('YYYY-MM-DD HH:mm:ss');
    };

    if (toSend.TransactionDate) {
      toSend.TransactionDate = formatForMySQL(toSend.TransactionDate) as any;
    }
    if (toSend.ReminderDate) {
      toSend.ReminderDate = formatForMySQL(toSend.ReminderDate) as any;
    }
    if (toSend.FinishDate) {
      toSend.FinishDate = formatForMySQL(toSend.FinishDate) as any;
    }

    // tslint:disable-next-line:object-literal-shorthand
    toSend.UUIDLastChange = uuid;

    return this.http
      .post<MessageCenterTransactionClass>(environment.URL + `/messagecenter/SETMessageCenterTransaction`, toSend)
      .pipe(
        map(resp => this.pickFirstRow<MessageCenterTransactionClass>(resp)!),
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  // Helper para apanhar o primeiro registo de respostas tipo CALL MySQL
  private pickFirstRow<T>(resp: any): T | null {
    if (resp == null) return null;
    if (Array.isArray(resp)) {
      // resp pode ser [[row]], [row], ou []
      if (resp.length === 0) return null;
      if (Array.isArray(resp[0])) return resp[0][0] ?? null;
      return resp[0] ?? null;
    }
    return resp as T;
  }

  SETMessageCenterTransactionOpened(
    data: Partial<MessageCenterTransactionOpenedClass>,
    uuid: string,
  ): Observable<MessageCenterTransactionOpenedClass> {
    const body: any = {
      idMessageCenterTransactionOpened: data.idMessageCenterTransactionOpened ?? null,
      idMessageCenterTransaction: data.idMessageCenterTransaction,
      idCustomer: data.idCustomer,
      DateStart: data.DateStart ?? new Date(), // se preferires, mete null
      DateEnd: data.DateEnd ?? null,
      UUID: data.UUID ?? uuid,
      UUIDLastChange: data.UUIDLastChange ?? uuid,
    };

    return this.http.post<any>(`${environment.URL}/messagecenter/SETMessageCenterTransactionOpened`, body).pipe(
      map(resp => this.pickFirstRow<MessageCenterTransactionOpenedClass>(resp)!),
      tap(_row => {}),
      catchError(error => {
        const msg = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => msg);
      }),
    );
  }

  GetMessageCenterQuizDescriptionsUntilOwnerZero(idMessageCenterQuiz: number): Observable<string> {
    return this.http
      .get<any>(
        environment.URL + `/messagecenter/GetMessageCenterQuizDescriptionsUntilOwnerZero/${idMessageCenterQuiz}`,
      )
      .pipe(
        map(response => {
          if (Array.isArray(response)) {
            const first = response[0];
            return (first?.Description ?? first?.description ?? (typeof first === 'string' ? first : '')) as string;
          }
          return (response?.Description ??
            response?.description ??
            (typeof response === 'string' ? response : '')) as string;
        }),
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  SetMessageCenterQuiz(messageCenterQuizClass: MessageCenterQuizClass, uuid: string): Observable<any> {
    // tslint:disable-next-line:object-literal-shorthand
    messageCenterQuizClass.UUIDLastChange = uuid;

    return this.http.post(environment.URL + `/messagecenter/SetMessageCenterQuiz`, messageCenterQuizClass).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  GETMessageCenterQuiz(
    idMessageCenterQuizOwner: number,
    idCompanie: number,
    idProduct: number,
    idProductsTypes: number,
  ): Observable<MessageCenterQuizClass[]> {
    return this.http
      .get<
        MessageCenterQuizClass[]
      >(environment.URL + `/messagecenter/GETMessageCenterQuiz/${idMessageCenterQuizOwner}/${idCompanie}/${idProduct}/${idProductsTypes}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  GETMessageCenterQuizID(idInsurancePolicyCompanyRequestsQuiz: number): Observable<MessageCenterQuizClass[]> {
    return this.http
      .get<
        MessageCenterQuizClass[]
      >(environment.URL + `/messagecenter/GETMessageCenterQuizID/${idInsurancePolicyCompanyRequestsQuiz}`)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  // =====================================================
  // EMAIL TEMPLATES
  // =====================================================

  GetEmailTemplates(auditMediators: boolean = false): Observable<any[]> {
    const query = auditMediators ? '?auditMediators=1' : '';
    return this.http.get<any[]>(environment.URL + `/messagecenter/EmailTemplates${query}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  SetEmailTemplate(dados: any): Observable<any> {
    return this.http.post<any>(environment.URL + `/messagecenter/EmailTemplates`, dados).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ToggleTemplateMediatorVisibility(payload: {
    id?: number;
    ids?: number[];
    visibleToMediators: boolean;
  }): Observable<any> {
    return this.http
      .post<any>(environment.URL + `/messagecenter/EmailTemplates/toggle-mediator-visibility`, payload)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  ReorderEmailTemplates(items: { ID: number; SortOrder: number }[]): Observable<any> {
    return this.http.post<any>(environment.URL + `/messagecenter/EmailTemplates/reorder`, { items }).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  ToggleTop10EmailTemplate(id: number, isTop10: boolean, sortOrder?: number): Observable<any> {
    return this.http
      .post<any>(environment.URL + `/messagecenter/EmailTemplates/toggle-top10`, { id, isTop10, sortOrder })
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  DeleteEmailTemplate(id: number): Observable<any> {
    return this.http.delete<any>(environment.URL + `/messagecenter/EmailTemplates/${id}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  // =====================================================
  // MARKETING GALLERY IMAGES
  // =====================================================

  GetGalleryImages(): Observable<any[]> {
    return this.http.get<any[]>(environment.URL + `/messagecenter/GalleryImages`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  SetGalleryImage(dados: any): Observable<any> {
    return this.http.post<any>(environment.URL + `/messagecenter/GalleryImages`, dados).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  DeleteGalleryImage(id: number): Observable<any> {
    return this.http.delete<any>(environment.URL + `/messagecenter/GalleryImages/${id}`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  // =====================================================
  // EMAIL DE SUPORTE
  // =====================================================

  /**
   * Envia um email profissional ao cliente associado a um ticket
   */
  SendEmail(data: {
    to: string;
    cc?: string;
    bcc?: string;
    subject: string;
    bodyHtml: string;
    idMessageCenterTransaction: number;
    idCustomer?: number;
    idCommercial?: number;
    clientName?: string;
    from?: string;
    attachments?: Array<{ filename: string; content: string; contentType: string }>;
    attachmentReferences?: Array<{ filename: string; filePath?: string }>;
    isMarketing?: boolean;
    replyTo?: string;
  }): Observable<{ success: boolean; messageId?: string; message?: string }> {
    return this.http
      .post<{
        success: boolean;
        messageId?: string;
        message?: string;
      }>(environment.URL + `/messagecenter/SendEmail`, data)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }

  /**
   * Testa a ligação SMTP do email de suporte
   */
  TestSMTP(): Observable<{ success: boolean; error?: string }> {
    return this.http.get<{ success: boolean; error?: string }>(environment.URL + `/messagecenter/TestSMTP`).pipe(
      catchError(error => {
        const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
        return throwError(() => errorMessage);
      }),
    );
  }

  /**
   * Cria um ticket de pedido de apoio anónimo (sem autenticação JWT).
   * Utiliza o endpoint público protegido apenas por API Key.
   */
  CreateAnonymousSupportTicket(data: {
    name: string;
    email: string;
    phone: string;
    message: string;
  }): Observable<{ success: boolean; idMessageCenterTransaction?: number }> {
    return this.http
      .post<{
        success: boolean;
        idMessageCenterTransaction?: number;
      }>(environment.URL + `/messagecenter/CreateAnonymousSupportTicket`, data)
      .pipe(
        catchError(error => {
          const errorMessage: string = HttpclienterrorService.getServerErrorMessage(error);
          return throwError(() => errorMessage);
        }),
      );
  }
}
